var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eolas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2055556,15.867222 L10.985,15.867222 L10.985,10.9849998 L9.76444447,10.9849998 M21.9700001,10.9849998 C21.9700001,14.9095624 19.876271,18.5360077 16.4775001,20.498289 C13.0787292,22.4605703 8.89127083,22.4605703 5.49249997,20.498289 C2.09372911,18.5360077 5.42035554e-16,14.9095624 5.42035554e-16,10.9849998 C5.42035554e-16,4.9181519 4.91815213,0 10.985,0 C17.0518479,0 21.9700001,4.9181519 21.9700001,10.9849998 L21.9700001,10.9849998 Z M10.3747223,7.32333336 C11.3858636,7.32333336 12.2055556,6.50364135 12.2055556,5.49250002 C12.2055556,4.48135868 11.3858636,3.66166668 10.3747223,3.66166668 C9.36358092,3.66166668 8.54388892,4.48135868 8.54388892,5.49250002 C8.54388892,6.50364135 9.36358092,7.32333336 10.3747223,7.32333336 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.0965fa23e5310e70155533a31cfe56cd.svg";
export { ForwardRef as ReactComponent };